import c from 'classnames';

import { Typography, Modal, Icon } from '@repo/ui';

import styles from './ConditionInfoModal.module.css';

type ConditionInfoModalProps = {
  showModal: boolean;
  toggle: () => void;
};

export const ConditionInfoModal = ({
  showModal,
  toggle,
}: ConditionInfoModalProps) => {
  return (
    <Modal isOpen={showModal} onClose={toggle} showHeader>
      <div className='flex flex-column align-items-center gap-4 text-center'>
        <div className={styles.circledIcon}>
          <Icon name='alertTriangleFilled' size='l' />
        </div>
        <Typography variant='heading-s' className={c('mb-2', styles.title)}>
          This test does not diagnose any health conditions
        </Typography>
        <Typography variant='body-s' className={styles.secondaryText}>
          This section shows metrics that may be associated with these
          conditions. Lifestyle, genetics, and other factors may also influence
          the presence of these conditions.
        </Typography>
      </div>
    </Modal>
  );
};
